import React from 'react';

const UsageConsiderations = () => {
    return (
        <div className="usage-considerations">
            <div className="container">
                <h2>1. Purpose and Scope</h2>
                <p>CampusAI is a <strong>Chrome extension</strong> designed to help students <strong>complete assignments more efficiently</strong> by providing AI-powered assistance directly within their university software...</p>

                <h2>2. User Responsibilities</h2>
                <ul>
                <li><strong>AI as a Learning Aid, Not a Shortcut</strong>
                    <ul>
                    <li>CampusAI is designed to <strong>assist with understanding concepts</strong> and structuring assignments but is <strong>not a replacement</strong> for original work.</li>
                    <li>Users must <strong>actively engage</strong> with AI-generated suggestions rather than copying responses directly.</li>
                    </ul>
                </li>
                <li><strong>Compliance with Academic Integrity Policies</strong>
                    <ul>
                    <li>Students are responsible for ensuring that their use of CampusAI <strong>complies with their institution’s academic honesty policies</strong>.</li>
                    <li>The tool should <strong>not be used to bypass learning objectives</strong>, plagiarize, or generate entire assignments <strong>without modification</strong>.</li>
                    </ul>
                </li>
                <li><strong>Accuracy and Verification</strong>
                    <ul>
                    <li>AI-generated responses should be <strong>reviewed for accuracy</strong> and alignment with coursework requirements.</li>
                    <li>Students should <strong>cross-check AI-provided sources</strong> and explanations before submitting assignments.</li>
                    </ul>
                </li>
                </ul>

                <h2>3. Data Collection & Usage (Important Disclosure)</h2>
                <p>CampusAI collects the text you interact with (such as assignment content and prompts) specifically to provide AI-powered suggestions and academic assistance. This data is transmitted securely to our AI processing services to generate real-time responses.</p>
                <p><strong>Privacy First:</strong> We do not collect passwords, login credentials, or any personal identification data (PII).</p>
                <p><strong>Real-Time Processing:</strong> Data is processed in real-time and is not stored or retained after your session ends.</p>
                <h3>
                    <strong>User Consent</strong>
                </h3>
                <p>By using CampusAI, you agree to this data processing as described above. Data is only processed when you actively engage with the extension’s features. You may opt out and stop all data collection at any time by disabling or removing the extension from your browser.</p>

                <h2>4. Features & Limitations</h2>
                <h3>✔️ Supported Features:</h3>
                <ul>
                <li class="checkmark">Assignment Structuring – Generates outlines, thesis statements, and research points.</li>
                <li class="checkmark">Clarifications & Explanations – Breaks down difficult concepts in real time.</li>
                <li class="checkmark">Writing & Grammar Feedback – Improves clarity, flow, and grammar in essays.</li>
                <li class="checkmark">Citation Assistance – Helps generate properly formatted references.</li>
                <li class="checkmark">Mathematical & Coding Support – Assists with equations, formulas, and code structure.</li>
                </ul>

                <h3>❌ Limitations:</h3>
                <ul>
                <li class="crossmark">Not a Homework Answer Generator – CampusAI helps with <strong>understanding concepts</strong>, not just providing answers.</li>
                <li class="crossmark">Context Sensitivity – The tool can <strong>only analyze what’s on-screen</strong> and may lack full course-specific context.</li>
                <li class="crossmark">No Real-Time Instructor Feedback – AI suggestions should be <strong>reviewed by students or instructors</strong> for alignment with course expectations.</li>
                </ul>

                <h2>5. Responsible & Ethical Use</h2>
                <p>CampusAI is intended for <strong>learning enhancement, not academic dishonesty</strong>.</p>

                <h3>✔️ Recommended Uses:</h3>
                <ul>
                <li class="checkmark">Clarifying confusing <strong>assignment prompts or instructions</strong></li>
                <li class="checkmark">Generating <strong>structured ideas</strong> for essays and reports</li>
                <li class="checkmark">Improving writing quality and <strong>proofreading assignments</strong></li>
                <li class="checkmark">Explaining <strong>mathematical or coding problems</strong> in a step-by-step manner</li>
                </ul>

                <h3>❌ Prohibited Uses:</h3>
                <ul>
                <li class="crossmark">Directly copying AI-generated responses without modification</li>
                <li class="crossmark">Using AI-generated content in place of personal effort in exams or tests</li>
                <li class="crossmark">Submitting AI-assisted work as <strong>100% original without personal engagement</strong></li>
                </ul>

                <h2>6. Liability Disclaimer</h2>
                <p>CampusAI is an <strong>academic support tool</strong> and <strong>does not assume responsibility</strong> for any misuse related to plagiarism or academic violations...</p>

                <h2>7. Contact & Support</h2>
                <p>For technical issues, feedback, or inquiries about <strong>ethical AI use</strong>, contact <a href="mailto:help@thecampusai.com">help@thecampusai.com</a></p>
            </div>
        </div>
    );
};

export default UsageConsiderations;
